import { isNumber, isString } from '../utils.js';


/**
 * Create String from BEM entities.
 *
 * @param {Object} entities - A collection of BEM entities.
 * @param {String} entities.block - Block name.
 * @param {String} [entities.el] - Element.
 * @param {Object<string>} [entities.mods] - Modifiers.
 * @param {String} [entities.mixin] - Mixin.
 * @param {Object.<String>} delimiters - Delimiters for BEM entities.
 *
 * @returns {String}
 */
export default function bemNames(entities, delimiters) {
  let resultString = entities.block;

  if (entities.el) {
    resultString += delimiters.el + entities.el;
  }

  if (entities.mods) {
    resultString += Object.keys(entities.mods).reduce((prev, name) => {
      const val = entities.mods[name];

      if (val === true) {
        prev += ` ${resultString}${delimiters.mod}${name}`;
      } else if (isString(val) || isNumber(val)) {
        prev += ` ${resultString}${delimiters.mod}${name}${delimiters.modVal}${val}`;
      }

      return prev;
    }, '');
  }

  return resultString + (entities.mixin ? ` ${entities.mixin}` : '');
}
